import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import { apply_closed_text, is_invest_card_open } from '@/app/availlability_vars';
import ApplePayIcon from '@/assets/images/icons/ApplePayIcon';
import GarminPayIcon from '@/assets/images/icons/GarminPayIcon';
import GooglePayIcon from '@/assets/images/icons/GooglePayIcon';
import SamsungPayIcon from '@/assets/images/icons/SamsungPayIcon';
import TickIcon from '@/assets/images/icons/TickIcon';
import InvestCard from '@/assets/images/invest_card_img.webp';
import Light from '@/assets/images/right-light.svg';
import { BigTitle, Button, SubBody, SubTitle } from '@/components';

const payment = [
  {
    icon: <ApplePayIcon />,
    link: 'https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone'
  },
  {
    icon: <GooglePayIcon />,
    link: 'https://bankffin.kz/ru/page/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone'
  },
  {
    icon: <SamsungPayIcon />,
    link: 'https://bankffin.kz/ru/cards/samsung-pay-info'
  },
  {
    icon: <GarminPayIcon />,
    link: ''
  }
];

function LandingInvestBanner() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div tw='flex lg:flex-row flex-col-reverse sm:items-start items-center sm:gap-20 gap-10'>
      <div tw='flex flex-col justify-between gap-7'>
        <BigTitle
          text={'Карта инвестора для иностранных граждан'}
          twStyle={tw`sm:text-[50px] text-[32px] text-[#70FF6E]`}
        />
        <div tw='sm:py-5 flex flex-col lg:row-gap-5 row-gap-5 justify-between lg:mt-0 mt-5 '>
          <div tw='flex gap-2 items-center'>
            <TickIcon />
            <SubTitle text={'Оформление за 10 минут в отделении банка'} />
          </div>
          {/* <div tw='flex gap-2 items-center'>
            <TickIcon />
            <SubTitle text={'Моментальный выпуск цифровой карты'} />
          </div> */}
          <div tw='flex gap-2 items-center'>
            <TickIcon />
            <SubTitle text={'4 полноценных счёта в тенге, долларах, евро и рублях'} />
          </div>
          <div tw='flex gap-2 items-center'>
            <TickIcon />
            <SubTitle text={'Доход на остаток — 3% годовых в долларах'} />
          </div>
          <div tw='flex gap-2 items-center'>
            <TickIcon />
            <SubTitle text={'Привязана к счёту во Freedom Finance Global PLC'} />
          </div>
        </div>
        <div tw='flex sm:justify-between gap-2 sm:w-1/3'>
          {payment.map((item, idx) => (
            <a href={item.link} tw='' key={idx}>
              <div tw='bg-[#ffff] py-3 px-3 h-[36px] flex justify-center items-center rounded-[8px] w-full'>
                {item.icon}
              </div>
            </a>
          ))}
        </div>
        <div tw='sm:text-left text-center'>
          <Button
            variant='ghost'
            twStyle={tw`sm:max-w-[200px] text-center`}
            disabled={!is_invest_card_open}
            onClick={() => {
              navigate('/invest-card/apply');
            }}
          >
            {'Заказать карту'}
          </Button>
        </div>
        {!is_invest_card_open && (
          <SubBody
            text={<span>{apply_closed_text}</span>}
            twStyle={tw`text-secondary -mt-5 text-justify sm:px-0 px-3`}
          />
        )}
        {is_invest_card_open && (
          <SubBody text={t('deposit.deposit_banner.caption')} twStyle={tw`text-secondary -mt-5 text-justify`} />
        )}
      </div>

      <div tw='flex flex-col gap-5 mt-5 relative items-center 2xl:w-[600px]'>
        <img src={InvestCard} alt='картинка' tw='' />
        <img src={Light} alt='' tw='mr-10' />
      </div>
    </div>
  );
}

export default LandingInvestBanner;
